/**
 * Preferências de aviso do PORTAL (D3, passo 19 — PR 2) — `/portal/notifications/preferences/avisos` (PR 1, Task 2): a mesma forma da API
 * do colaborador, só com as 3 categorias do portal. Usa o axios do PORTAL (token do parceiro); o caminho nunca leva `/api/v1`.
 * 🔴 Só importa TIPOS do serviço interno: importar o valor traria o axios interno (um 401 interno apaga o `seweb_auth`).
 */
import portalApi from "@/services/portalApi";
import type {
  AdaptadorDePreferencias,
  CategoriaDeAviso,
  NivelDeAviso,
  PreferenciasDeAviso,
} from "@/services/preferenciasDeAvisoService";

const BASE = "/portal/notifications/preferences/avisos";

export const CHAVE_DAS_PREFERENCIAS_DO_PORTAL = ["portal", "preferencias-de-aviso"] as const;

export const portalPreferenciasDeAvisoService = {
  listar: async (): Promise<PreferenciasDeAviso> =>
    (await portalApi.get<PreferenciasDeAviso>(BASE)).data,
  definir: async (chave: string, nivel: NivelDeAviso): Promise<CategoriaDeAviso> =>
    (await portalApi.put<CategoriaDeAviso>(`${BASE}/${encodeURIComponent(chave)}`, { nivel })).data,
  restaurarPadroes: async (): Promise<void> => {
    await portalApi.delete(BASE);
  },
};

export const ADAPTADOR_DO_PORTAL: AdaptadorDePreferencias = {
  chaveDoCache: CHAVE_DAS_PREFERENCIAS_DO_PORTAL,
  listar: () => portalPreferenciasDeAvisoService.listar(),
  definir: (chave, nivel) => portalPreferenciasDeAvisoService.definir(chave, nivel),
  restaurarPadroes: () => portalPreferenciasDeAvisoService.restaurarPadroes(),
};
